import detail from './detail';
import list from './list';
import { buildModule } from '../utils';

export default buildModule()
	.withSubmodules({
		detail,
		list,
	});
